import { colorConstants } from 'config/colorConstants';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const GenAIIcon = ({ stroke = colorConstants.violet }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 4C6.68633 4.00001 4.00004 6.68634 4 10C4 13.3137 6.6863 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68633 13.3137 4 10 4Z"
                    fill="url(#paint0_linear_5154_3071)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_5154_3071"
                        x1="16.6667"
                        y1="1.25"
                        x2="2.5"
                        y2="18.3333"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#E8A122" />
                        <stop offset="0.150972" stop-color="#C03535" />
                        <stop offset="0.314237" stop-color="#3B2C77" />
                        <stop offset="0.737827" stop-color="#3B2C77" />
                        <stop offset="0.918722" stop-color="#37C7BE" />
                    </linearGradient>
                </defs>
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 4C6.68633 4.00001 4.00004 6.68634 4 10C4 13.3137 6.6863 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68633 13.3137 4 10 4Z"
                    fill="url(#paint0_linear_5154_3071)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_5154_3071"
                        x1="16.6667"
                        y1="1.25"
                        x2="2.5"
                        y2="18.3333"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#E8A122" />
                        <stop offset="0.150972" stop-color="#C03535" />
                        <stop offset="0.314237" stop-color="#3B2C77" />
                        <stop offset="0.737827" stop-color="#3B2C77" />
                        <stop offset="0.918722" stop-color="#37C7BE" />
                    </linearGradient>
                </defs>
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 4C6.68633 4.00001 4.00004 6.68634 4 10C4 13.3137 6.6863 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68633 13.3137 4 10 4Z"
                fill="url(#paint0_linear_5154_3071)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_5154_3071"
                    x1="16.6667"
                    y1="1.25"
                    x2="2.5"
                    y2="18.3333"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#E8A122" />
                    <stop offset="0.150972" stop-color="#C03535" />
                    <stop offset="0.314237" stop-color="#3B2C77" />
                    <stop offset="0.737827" stop-color="#3B2C77" />
                    <stop offset="0.918722" stop-color="#37C7BE" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default GenAIIcon;
